<template>
  <section>
    <h2>User Dashboard</h2>
    <p>Welcome, regular user!</p>
  </section>
</template>
